//var homepages = [ '/', 'index.html', 'index.php', 'main.html', 'main.htm', 'homepage.html', 'index2.htm' ]; 

//if (homepages.indexOf(window.location.pathname) >= 0) {
  // we might be on a "homepage"
  // console.log('homepage');
  var html = '<div class="blobdiv blob1"><svg viewBox="0 0 1000 1000"><path class="blob" data-circle=""></path></svg><a href="/strategie" title="Strategie">Strategie</a></div><div class="blobdiv blob2"><svg viewBox="0 0 1000 1000"><path class="blob" data-circle=""></path></svg><a href="/offline-communicatie" class="multiple" title="Offline communicatie">Offline communicatie</a></div><div class="blobdiv blob3"><svg viewBox="0 0 1000 1000"><path class="blob" data-circle=""></path></svg><a href="/websites" title="Website">Websites</a></div><div class="blobdiv blob4"><svg viewBox="0 0 1000 1000"><path class="blob" data-circle=""></path></svg><a href="/online-marketing" class="multiple" title="Online marketing">Online marketing</a></div><div class="blobdiv blob5"><svg viewBox="0 0 1000 1000"><path class="blob" data-circle=""></path></svg><a href="/creatie" title="Creatie">Creatie</a></div>';

  // var lijnengroep = document.querySelectorAll('.is-style-indrukwekkend-lijnenspel');
  var headerblob =  document.getElementById('blobholder');
  if (headerblob) {
    headerblob.innerHTML = html;
  }

  var html1 ='<div class="blobdiv blob1"><svg viewBox="0 0 1000 1000"><path class="blob" data-circle=""></path></svg><a class="single" href="/strategie" title="Strategie">Strategie</a></div>';
  var html2 ='<div class="blobdiv blob2"><svg viewBox="0 0 1000 1000"><path class="blob" data-circle=""></path></svg><a class="single" href="/offline-communicatie" title="Offline communicatie">Offline communicatie</a></div>';
  var html3 ='<div class="blobdiv blob3"><svg viewBox="0 0 1000 1000"><path class="blob" data-circle=""></path></svg><a class="single" href="/websites" title="Website">Websites</a></div>';
  var html4 ='<div class="blobdiv blob4"><svg viewBox="0 0 1000 1000"><path class="blob" data-circle=""></path></svg><a class="single" href="/online-marketing" title="Online marketing">Online marketing</a></div>';
  var html5 ='<div class="blobdiv blob5"><svg viewBox="0 0 1000 1000"><path class="blob" data-circle=""></path></svg><a class="single" href="/creatie" title="Creatie">Creatie</a></div>';

  // var blob1 = document.querySelector('.blob1');
  var blob1 = document.getElementById('blob_strategie');
  var blob2 = document.getElementById('blob_offline');
  var blob3 = document.getElementById('blob_websites');
  var blob4 = document.getElementById('blob_online');
  var blob5 = document.getElementById('blob_creatie');

  if (blob1) {
    blob1.innerHTML = html1;
  }
  if (blob2) {
    blob2.innerHTML = html2;
  }
  if (blob3) {
    blob3.innerHTML = html3;
  }
  if (blob4) {
    blob4.innerHTML = html4;
  }
  if (blob5) {
    blob5.innerHTML = html5;
  }
//}
